import styled from '@xstyled/styled-components';
import backgroundImage from './assets/onboarding-background.jpg';

export const Background = styled.div`
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-image: url(${backgroundImage});
`;
